const columns = [
  {
    title: "Rank",
    key: "rank",
    dataIndex: "rank",
  },
  {
    title: "Login",
    dataIndex: "login",
    key: "login",
  },
  {
    title: "Trader",
    dataIndex: "trader",
    key: "trader",
  },
  { title: "Profit", dataIndex: "profitUI", key: "profitUI" },
  { title: "Profit %", dataIndex: "profitPercents", key: "profitPercents" },
  { title: "Win Ratio", dataIndex: "winRatios", key: "winRatios" },
  { title: "Pair", dataIndex: "pair", key: "pair" },
  { title: "Avg. Win", dataIndex: "avgWins", key: "avgWins" },
  { title: "Avg. Loss", dataIndex: "avgLosses", key: "avgLosses" },
  { title: "Avg. Duration", dataIndex: "avgDuration", key: "avgDuration" },
  { title: "Trades", dataIndex: "trades", key: "trades" },
  { title: "Losing Streak", dataIndex: "losingStreak", key: "losingStreak" },
  { title: "Winning Streak", dataIndex: "winningStreaks", key: "winningStreaks" },
  { title: "Total Lots", dataIndex: "totalLot", key: "totalLot" },
];

export default columns;
